var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoBlueIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.875,
    cy: 7.875,
    r: 7.875,
    transform: "matrix(1 0 0 -1 1.125 16.875)",
    fill: "#4C6AFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 12.713V7.875",
    stroke: "#fff",
    strokeWidth: 1.125,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.674 5.513a.675.675 0 10-1.35 0 .675.675 0 001.35 0z",
    fill: "#fff"
  })));
}
export default __webpack_public_path__ + "static/info_blue_icon.21e1a95d.svg";
export { SvgInfoBlueIcon as ReactComponent };